import React from 'react';
import { useCachedData } from '../../../connection/CacheContext';

const JobPostingSchema = ({ job, recruiter }) => {
  const { masterdata, mainType } = useCachedData();
  const employment_types = {
    'Full Time': 'FULL_TIME',
    'Part Time': 'PART_TIME',
    Contract: 'CONTRACTOR',
    Internship: 'INTERN',
    Other: 'OTHER',
  };

  const unitText_types = {
    Hour: 'HOUR',
    Day: 'DAY',
    // WEEK: 'WEEK',
    Month: 'MONTH',
    Year: 'YEAR',
  };

  const country = masterdata[mainType.Country]?.find((item) => item?.id === job?.country[0]);

  const WorkplaceType =
    masterdata[mainType['Workplace Type']]?.find((item) => item?.id === job?.workplaceType)
      ?.value === 'Remote'
      ? 'TELECOMMUTE'
      : undefined;

  const categories = masterdata[mainType['Job Category']]?.filter((item) =>
    job?.jobCategory?.includes(item?.id),
  );
  const type = masterdata[mainType['Job Types']]?.filter((item) =>
    job?.jobType?.includes(item?.id),
  );
  const employmentType = Array.from(
    new Set(
      categories?.concat(type).map((e: any) => {
        return employment_types[e.value] ?? 'OTHER';
      }),
    ),
  );

  const extractSalaryDetails = (str) => {
    const regex = /([A-Z]+)\s+(\d+,\d+)\s+-\s+([A-Z]+)\s+(\d+,\d+)\s+\/\s+(\w+)/;
    const match = str.match(regex);
    if (match) {
      return {
        currency: match[1],
        salaryStart: match[2].replace(/,/g, ''), // Remove commas from the number
        salaryEnd: match[4].replace(/,/g, ''), // Remove commas from the number
        unitText: unitText_types[match[5]],
      };
    }
    return null;
  };

  const schema = {
    '@context': 'https://schema.org/',
    '@type': 'JobPosting',
    title: job?.jobTitle,
    description: job?.description,
    datePosted: job?.activeDate,
    validThrough: job?.expireDate,
    applicantLocationRequirements: {
      '@type': 'Country',
      name: country ?? undefined,
    },
    jobLocationType: WorkplaceType, //if remote only index from master data workplaceType
    employmentType: employmentType ?? 'OTHER', //employment_types
    hiringOrganization: {
      '@type': 'Organization',
      name: job?.recruiterName,
      sameAs: job?.recruiter?.website,
      logo: job?.recruiterImage,
    },
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        streetAddress: job?.recruiter?.addressLine1,
        addressLocality: masterdata[mainType.Location]?.find(
          (item) => item?.id === job?.recruiter?.location,
        )?.value,
        addressCountry: job?.recruiter?.country,
      },
    },

    baseSalary: {
      '@type': 'MonetaryAmount',
      currency: extractSalaryDetails(job?.salaryValue)?.currency, //if salaryDisplay is not equal to Do Not Display
      value: {
        '@type': 'QuantitativeValue',
        value: extractSalaryDetails(job?.salaryValue)?.salaryStart, //if salaryDisplay is not equal to Do Not Display
        unitText: extractSalaryDetails(job?.salaryValue)?.unitText,
      },
    },
  };

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
};

export default JobPostingSchema;
